// Item library evaluate codes for /roads-sewers/storm-sewers Conc (Carlow) Tank
// Attenuation build-up dev-mode display — mirrors prelimsMapping.ts's
// description -> code lookup pattern, but keyed off each row's `conc_<n>_<suffix>`
// id rather than its description text, since several descriptions embed a
// live-configured value (MOT Type 1 thickness, haul road width/thickness,
// crane visit/programme days, concrete pump days, concrete/mortar volumes,
// steel tonnage, skip count) and/or the supplier name (default "Carlow",
// user-configurable via the tab's Supplier Text Type control) — both of which
// would otherwise stop matching a plain exact/pattern text lookup.
//
// Rows with no code given (75mm concrete blinding, Scabbling to concrete
// surfaces, Hydrophillic waterstop, 225mm concrete slab, Reinforcement mesh,
// Add x% FP/OHP on above, 900 x 675mm access opening, Precast slab with
// opening) are intentionally left out of the map.

export interface StormConcAttenuationEvaluateCodeItem {
  suffix: string;
  code: string;
}

export const CONC_ATTENUATION_EVALUATE_CODES: StormConcAttenuationEvaluateCodeItem[] = [
  { suffix: 'excPit', code: 'APATT001' },
  { suffix: 'backfillWS', code: 'APATT002' },
  { suffix: 'backfillPit', code: 'APATT003' },
  { suffix: 'levelComp', code: 'ALP035' },
  { suffix: 'mot150', code: 'ALP017c' },
  { suffix: 'supplyCar', code: 'SCSATT028' },
  { suffix: 'install', code: 'SCSATT005' },
  { suffix: 'lpAttend', code: 'ACL004' },
  { suffix: 'brickwork', code: 'GWALPSMH018' },
  { suffix: 'liftEquip', code: 'SCSATT014' },
  { suffix: 'scaffold', code: 'SCSATT015' },
  { suffix: 'haulRoad', code: 'ALP016' },
  { suffix: 'removeHaul', code: 'ALP014+ALP033a' },
  { suffix: 'crane', code: 'SCSATT016' },
  { suffix: 'concPump', code: 'SCSATT017' },
  { suffix: 'leadEdge', code: 'APATT005' },
  { suffix: 'conc58', code: 'RMC0004' },
  { suffix: 'mortar1', code: 'RMC0030' },
  { suffix: 'steel', code: 'MESH0008' },
  { suffix: 'formwork', code: 'SCSATT019' },
  { suffix: 'skip', code: 'SCSATT018' },
];

/** Selectable supply items for a tank's "Supply of Carlow materials" row (`c` = code, `n` = name). */
export const CONC_SUPPLY_OPTIONS: { c: string; n: string }[] = [
  { c: 'SCSATT028', n: 'FPI Carlow Supply - 1' },
  { c: 'SCSATT029', n: 'FPI Carlow Supply - 2' },
  { c: 'SCSATT030', n: 'FPI Carlow Supply - 3' },
];

export function findConcAttenuationEvaluateCode(rowId: string): string | undefined {
  const suffix = rowId.match(/^conc_\d+_(.+)$/)?.[1];
  return CONC_ATTENUATION_EVALUATE_CODES.find((i) => i.suffix === suffix)?.code;
}

/** Row's own `code` (a configured override) wins over the id-based mapping. */
export const resolveConcAttenuationEvaluateCode = (row: { id: string; code?: string }): string | undefined =>
  row.code ?? findConcAttenuationEvaluateCode(row.id);
